var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2896_24576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7C1.27539 3.13401 4.4094 0 8.27539 0H42.2754C46.1414 0 49.2754 3.13401 49.2754 7V41C49.2754 44.866 46.1414 48 42.2754 48H8.27539C4.4094 48 1.27539 44.866 1.27539 41V7Z",
    fill: "#FAEFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2754 34C16.7254 34 16.2546 33.8042 15.8629 33.4125C15.4712 33.0208 15.2754 32.55 15.2754 32V20C15.2754 19.45 15.4712 18.9792 15.8629 18.5875C16.2546 18.1958 16.7254 18 17.2754 18H21.2754V16C21.2754 15.45 21.4712 14.9792 21.8629 14.5875C22.2546 14.1958 22.7254 14 23.2754 14H27.2754C27.8254 14 28.2962 14.1958 28.6879 14.5875C29.0796 14.9792 29.2754 15.45 29.2754 16V18H33.2754C33.8254 18 34.2962 18.1958 34.6879 18.5875C35.0796 18.9792 35.2754 19.45 35.2754 20V32C35.2754 32.55 35.0796 33.0208 34.6879 33.4125C34.2962 33.8042 33.8254 34 33.2754 34H17.2754ZM23.2754 18H27.2754V16H23.2754V18ZM24.2754 27V30H26.2754V27H29.2754V25H26.2754V22H24.2754V25H21.2754V27H24.2754Z",
    fill: "#D45599"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2896_24576",
    x: 0.275391,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2896_24576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2896_24576",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon);
export default __webpack_public_path__ + "static/media/integration-icon.f71fe18e4b1f310b3c3efd6390e943f5.svg";
export { ForwardRef as ReactComponent };